import React from "react";
import Layout from "../../layouts/Layout";
import HeadingWithBtns from "../../Components/Common/HeadingWithBtns";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import CommunityContent from "../../Components/Community/CommunityContent";

const Search = () => {
  const { searchTerm } = useParams();

  return (
    <Layout>
      <HeadingWithBtns title={`Search results for "${searchTerm}"`} creator />

      <Box sx={{ mt: 4 }}>
        <CommunityContent />
      </Box>
    </Layout>
  );
};

export default Search;
